import AxiosInstance from './config/Http'
import Config from './config/Constants'
import { fetchAllPages } from './config/Pagination'

export default {
    get: () => AxiosInstance.get<any>(`${Config.core.dashboard}/true`),

    getVehicle: () => AxiosInstance.get<any>(`${Config.core.vehicles}`),

  generateVehicleExcel: (params: any) =>
   AxiosInstance.get(`${Config.core.vehiclesExcel}`, {
    params,
    responseType: "blob",
    headers: {
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  }),

    getDocumentsVto: (filter: string) =>
      fetchAllPages<any>(`${Config.core.documenttsVto}`, {
        sort: 'dueDate,asc',
        ...Object.fromEntries(
          new URLSearchParams(filter.startsWith('&') ? filter.slice(1) : filter).entries()
        ),
      }),

     generateDocumentExcel: (params: any) =>
       AxiosInstance.get(`${Config.core.documentsExcel}`, {
        params,
        responseType: "blob",
        headers: {
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      }),
}
